(ns frontend.view.grid.fund-commitments-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce fund-commitments (r/cursor app-db/views [:fund-commitments]))
(defonce modal-state (r/cursor fund-commitments [:modals]))
(defonce grid-entities (r/cursor fund-commitments [:grid-entities]))
(defonce view-settings (r/cursor fund-commitments [:view-settings]))
(defonce fund-commitment-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor fund-commitments [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor fund-commitments [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor fund-commitments [:schema]))
